import React, { useState, useEffect, useCallback } from "react";
import Helmet from "react-helmet";
import FadeLoader from "react-spinners/FadeLoader";
import * as Path from "routes/Path/index";
import { toast } from "react-toastify";
import Table from "components/Table";
import Columns from "./Columns";
import { Link, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { getFeedbackList } from "store/feedback/actions";
import { PENDINGFEEDBACKS } from "common/viewContent";
const List = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { FEEDBACK, loading, totalCount } = useSelector(
    (state) => state?.Feedback
  );
  console.log(FEEDBACK,"FEEDBACK");
  
   const [search_text, setSearch_text] = useState("");
  const [columns, setcolumns] = useState([{ dataField: "", text: "" }]);
  const [feedback, setFeedback] = useState();
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(20);
  const [filter, setFilter] = useState({
    pageNo: currentPage,
    limit: pageSize,
    search_text: "",
  });
  const fetchData = async (filter) => {
    const payload = {
      ...filter,
      page: filter?.pageNo,
      record_count: filter?.limit,
      feedbackStatus: "Pending",
    };
    try {
      const callback = (err, res) => {
        if (err) {
          toast.error(err);
        } else {
          setFeedback(res);
        }
      };
      dispatch(getFeedbackList({ data: payload, callback }));
    } catch (error) {
      console.error(error, "<===err");
    }
  };
  const onCliclNavigate = (id) => {
    navigate(`/admin/feedback/pending-feedback/${id}`);
  };
  useEffect(() => {
    fetchData(filter);
     setcolumns(Columns({ onCliclNavigate, currentPage: filter?.pageNo,pageSize}));
  }, [filter]);
  const handlePageChange = (pageNumber) => {
    console.log("pageNumber->", pageNumber);
    setCurrentPage(pageNumber);
  };
  const onClickFilter = (e) => {
    e?.preventDefault();
    setFilter({
      ...filter,
      pageNo: 1,
      limit: pageSize,
      search_text: search_text,
    });
  };
  const clearFilter = () => {
    setFilter((pre) => ({
      ...pre,
      pageNo: 1,
      search_text: "",
    }));
    setSearch_text("");
  };
  return (
    <>
      {loading && (
        <div className="main-loader">
          <FadeLoader size={1000} />
        </div>
      )}
      <Helmet title={PENDINGFEEDBACKS.CURRENT_MODULE} />
      <section className="section">
        <div className="section-header">
          <h1>{PENDINGFEEDBACKS.CURRENT_MODULE}</h1>

          <div className="section-header-breadcrumb">
            <div className="breadcrumb-item active">
              <Link to={"/admin/" + Path.dashboard}>Dashboard</Link>
            </div>
            <div className="breadcrumb-item">
              {PENDINGFEEDBACKS.CURRENT_MODULE}{" "}
            </div>
          </div>
        </div>
        <div className="section-body">
          <div className="card">
            <div className="row justify-content-between">
              <div className="col-6">
                <div className="card-header">
                  <h2 className="section-title">
                    {PENDINGFEEDBACKS.TOP_CONTENT}
                  </h2>
                </div>
              </div>
              <div className="col-12">
                <form onSubmit={onClickFilter}>
                  <div className="card-header">
                    <div className="col-lg-4 col-sm-12 col-md-12 my-2 px-0">
                      <input
                        className="form-control"
                        name="search_text"
                        onChange={(e) => setSearch_text(e.target.value)}
                        value={search_text}
                        placeholder="Search using name, email..."
                      />
                    </div>
                  </div>
                  <div className="col-12 my-2 gap-4 ">
                    <div className="d-flex gap-4">
                      <button type="submit" className="btn btn-primary btn-lg">
                        Search
                      </button>
                      <button
                        onClick={() => clearFilter()}
                        type="button"
                        className="btn btn-primary btn-lg"
                      >
                        Clear Search
                      </button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
          {!loading && FEEDBACK?.data?.length > 0 && (
            <Table
              data={FEEDBACK?.data}
              columns={columns}
              setFilter={setFilter}
              handleTableChange={handlePageChange}
              totalCount={totalCount}
              filter={filter}
            />
          )}
          {!loading && FEEDBACK?.length  === 0 && (
            <p style={{ textAlign: "center" }}>No Pending Feedback Found</p>
          )}
        </div>
      </section>
    </>
  );
};
export default List;
